const AdminTokenHolder = 'ADMIN_TOKEN_HOLDER'
const ApiMiddlewareToken = 'AUTHENTICATION_MIDDLEWARE'
const AppToken = 'APP'
const RouterToken = 'ROUTER'

export { AdminTokenHolder, ApiMiddlewareToken, AppToken, RouterToken }
